'use strict';
import makeRequest from "./makeRequest";
import { callbackifyPromiseWithTimeout, extractUrlParams } from "./utils";
export default function resourceMethod(spec) {
    return function (...args) {
        const callback = typeof args[args.length - 1] == 'function' && args.pop();
        spec.urlParams = extractUrlParams(this.createResourcePathWithSymbols(spec.path || ''));
        const requestPromise = callbackifyPromiseWithTimeout(makeRequest(this, args, spec, {}), callback);
        return requestPromise;
    };
}
//# sourceMappingURL=Method.js.map